import React from 'react';
import { ExpandableSection, Spinner } from 'AWS-UI-Components-React';
import { ViewByFeature } from './view_by_feature';
import { TEST_RESULT_TRANSITION_TIMEOUT } from './constants';

/**
 * Given a map of test results by time frame,
 * renders the test results putting each time frame
 * in an expandable section which display the
 * corresponding test results upon expansion.
 */
export class ViewByTimeFrame extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      contentByTimeFrame: {},
      loadingStatusByTimeFrame: {},
    };
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.testResultsByTimeFrame !== this.props.testResultsByTimeFrame) {
      Object.keys(this.props.testResultsByTimeFrame).forEach((timeFrame) => {
        const previousScenariosWithSteps = prevProps.testResultsByTimeFrame[timeFrame].filter(
          (result) => result.steps && result.steps.length
        );
        const currentScenariosWithSteps = this.props.testResultsByTimeFrame[timeFrame].filter(
          (result) => result.steps && result.steps.length
        );

        // Initially scenarios are loaded without the steps. So if there are higher number of scenarios that
        // have steps, that means one or more scenarios have loaded the steps (from backend) based on user action (click).
        // So refresh the view with these new steps.
        const newlyLoadedStep = currentScenariosWithSteps.length > previousScenariosWithSteps.length;
        if (newlyLoadedStep) {
          this.setLoadingStatus(timeFrame, true, () => this.setContent(timeFrame));
        }
      });
    }
  };

  onTimeFrameExpansionChange = (event, timeFrame) => {
    const { contentByTimeFrame } = this.state;
    if (!contentByTimeFrame[timeFrame]) {
      this.setLoadingStatus(timeFrame, true, () => this.setContent(timeFrame));
    }
  };

  setLoadingStatus = (timeFrame, status, callback = null) => {
    const { loadingStatusByTimeFrame } = this.state;
    this.setState(
      { loadingStatusByTimeFrame: { ...loadingStatusByTimeFrame, [timeFrame]: status } },
      () => setTimeout(callback, TEST_RESULT_TRANSITION_TIMEOUT)
    );
  };

  setContent = (timeFrame) => {
    const { testResultsByTimeFrame } = this.props;
    const { contentByTimeFrame } = this.state;
    const content = (
      <ViewByFeature
        validationTestResultItems={testResultsByTimeFrame[timeFrame]}
        loadValidationTestResults={this.props.loadValidationTestResults}
      />
    );
    this.setState(
      { contentByTimeFrame: { ...contentByTimeFrame, [timeFrame]: content } },
      this.setLoadingStatus(timeFrame, false)
    );
  };

  getHeader = (timeFrame) => {
    const { loadingStatusByTimeFrame } = this.state;
    return (
      <span>
        {loadingStatusByTimeFrame[timeFrame] ? <Spinner /> : ''}
        {timeFrame}
      </span>
    );
  };

  render() {
    const { title, testResultsByTimeFrame, chart } = this.props;
    const { contentByTimeFrame } = this.state;
    return (
      <div>
        <h2>{title}</h2>
        <div>{chart ? chart : ''}</div>
        {Object.keys(testResultsByTimeFrame)
          .sort()
          .reverse()
          .map((timeFrame) => {
            return (
              <ExpandableSection
                key={'TestResultsByFeature' + timeFrame}
                header={this.getHeader(timeFrame)}
                variant="borderless"
                onChange={(event) => this.onTimeFrameExpansionChange(event, timeFrame)}
              >
                {contentByTimeFrame[timeFrame]}
              </ExpandableSection>
            );
          })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/simulator/validation_test_results/view_by_timeframe.jsx